/**
 * Format an ISO timestamp as a short relative-time label suitable for
 * dense table cells: "12m", "3h", "5d", "Apr 12", "—" for missing.
 *
 * Distinct from a full timeago library — no "ago" suffix, no live ticker,
 * no localization. Used by the admin Users table "Active" column.
 */
export function formatRelativeShort(iso) {
  if (!iso) return '—';
  let d;
  try {
    d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '—';
  } catch {
    return '—';
  }
  const diffMs = Date.now() - d.getTime();
  if (diffMs < 0) return 'just now';

  const sec = Math.floor(diffMs / 1000);
  if (sec < 60) return 'just now';
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day}d`;
  if (day < 30) return `${Math.floor(day / 7)}w`;
  // Older than a month — switch to a calendar date.
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

/**
 * Tailwind text class to colour-code activity recency:
 *   <24h  → green  (active)
 *   <7d   → default
 *   <30d  → muted yellow
 *   >=30d → muted red (dormant)
 */
export function relativeColorClass(iso) {
  if (!iso) return 'text-muted-foreground';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return 'text-muted-foreground';
  const days = (Date.now() - d.getTime()) / (1000 * 60 * 60 * 24);
  if (days < 1) return 'text-emerald-600 dark:text-emerald-400';
  if (days < 7) return '';
  if (days < 30) return 'text-amber-600 dark:text-amber-400';
  return 'text-rose-600 dark:text-rose-400';
}
